import React from "react";
import Notificational from "./Notificational";
import Leftsidebar from "../sidebar/leftsidebar";
import LeftResponsivesidebar from "../sidebar/left-responsive";
import Headmenu from "../sidebar/headmenu";
import RightList from "../common/RightList";

const NotificationPage = () => {
  return (
    <div className="dashboard w-full min-h-screen  flex">
      {/* Sidebar */}
      <Leftsidebar />
      <main className="flex-1 min-w-0 p-4 md:p-6 md:pl-8">
        <LeftResponsivesidebar />
        <Headmenu />
        <main className="flex">
          {" "}
          <div className="w-[100%] flex ">
            <div className="w-[100%] lg:w-[70%]">
              <Notificational />
            </div>
            <div className="w-[30%] hidden lg:block">
              <RightList />
            </div>
          </div>
        </main>
      </main>
    </div>
  );
};

export default NotificationPage;
